var map = {
	"./Fire.png": "531f",
	"./boy-flag-raise.png": "215c",
	"./boy-flag.png": "bfa6",
	"./boy.png": "bbf7",
	"./boy2.png": "0f89",
	"./bucket.png": "42b5",
	"./door.png": "d638",
	"./goblin.png": "0a4d",
	"./keypad.png": "be31",
	"./mario.png": "2bd2",
	"./skinner-1-l.png": "729c",
	"./skinner-1-r.png": "09a3",
	"./skinner-2-l.png": "8007",
	"./skinner-2-r.png": "efe0",
	"./stairs.png": "2816",
	"./switch-flip.jpg": "0cd7",
	"./switch.jpg": "8e6d",
	"./testroom3platform.png": "b1e8",
	"./tube.png": "da7c",
	"./woman.png": "9f9b",
	"./woman2.png": "c877",
	"./woman2a.png": "bd00",
	"./woman2b.png": "3bde",
	"./womanWave.png": "2c2f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa86";